import React, { useEffect, useState, useContext } from "react";
import { ScreenContext } from "../contexts/ScreenContext";
import { ClientContext } from "../contexts/ClientContext";

import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";

import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { FixedSizeList } from "react-window";

const SPClients = () => {
  const { spClients, loadSPClients, spClientsLoading } =
    useContext(ClientContext);
  const { isMobile } = useContext(ScreenContext);

  const [loadedClients, setloadedClients] = useState([]);

  function renderRow(props) {
    const { data, index, style } = props;



    return (
      <ListItem
        button
        component="a"
        href={`https://pcsinconline.sharepoint.com${data[index].ServerRelativeUrl}`}
        target="_blank"
        style={style}
        key={index}
      >
        <ListItemText primary={`${data[index].Title}`} />
      </ListItem>
    );
  }

  useEffect(() => {
    if (spClients.length) {

      setloadedClients(spClients);
    }
  }, [spClients]);

  useEffect(() => {
    loadSPClients();
  }, []);

  return (
    <React.Fragment>
      <Grid
        container
        direction="row"
        alignItems="flex-start"
        justifyContent="flex-start"
      >
        <Grid item xs={12}>
          <Typography
            align="left"
            variant="h5"
            gutterBottom
          >{`SP Clients`}</Typography>
        </Grid>

        {spClientsLoading ? (
          <Grid container spacing={2}>
            <Grid item>
              <CircularProgress size={25} />
            </Grid>
            <Grid item>
              <Typography variant="overline">{`Loading...`}</Typography>
            </Grid>
          </Grid>
        ) : (
          <FixedSizeList
            height={400}
            width={"100%"}
            itemSize={46}
            itemData={loadedClients}
            itemCount={loadedClients.length}
          >
            {renderRow}
          </FixedSizeList>
        )}
      </Grid>
    </React.Fragment>
  );
};

export default SPClients;
